"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserHubAssociation = void 0;
const useLogger_1 = require("./useLogger");
const mutations_1 = require("../graphql/mutations");
const amplifyBootstrap_1 = require("../utils/amplifyBootstrap");
function useUserHubAssociation() {
    const logger = (0, useLogger_1.useLogger)('useUserHubAssociation');
    const associateHubWithUser = async (hubId) => {
        try {
            const response = await amplifyBootstrap_1.API.graphql({
                query: mutations_1.associateHub,
                variables: { hubId },
            });
            return response.data?.associateHub;
        }
        catch (error) {
            logger.error(`error associating a hub to the user, error: ${error}`);
            throw error;
        }
    };
    return {
        associateHubWithUser,
    };
}
exports.useUserHubAssociation = useUserHubAssociation;
exports.default = useUserHubAssociation;
